import React from "react";
import "./../../styles/components/Solutions.css";
import CurrentTheme from "./../CurrentTheme";
import config from "../../config";

export default function SolutionsFR() {
  return (
    <div className="solutions">
      <div className="bens-container">
        <div className="solutions-top">
          <div className="box-col">
            <div className="media-group">
              <a
                className="media-item"
                href="https://bens-digital-change.com/employeur#etape1"
                target="_blank"
                rel="noopener noreferrer"
              >
                <h4>1. Enregistrez votre employeur dans votre espace client</h4>
                <img
                  src="/img/sol-01_emp.png"
                  alt="Sol 01"
                  loading="lazy"
                  width={340}
                  height={341}
                />
              </a>

              <a
                className="media-item"
                href="https://bens-digital-change.com/employeur#etape2"
                target="_blank"
                rel="noopener noreferrer"
              >
                <h4>2. Validation de l’employeur par notre équipe</h4>
                <img
                  src="/img/sol-01_emp.png"
                  alt="Sol 02"
                  loading="lazy"
                  width={340}
                  height={351}
                />
              </a>
            </div>

            <div className="media-group">
              <a
                className="media-item"
                href="https://bens-digital-change.com/employeur#etape3"
                target="_blank"
                rel="noopener noreferrer"
              >
                <h4>
                  3. Téléchargez le document à remettre à votre employeur{" "}
                </h4>
                <img
                  src="/img/sol-01_emp.png"
                  alt="Sol 03"
                  loading="lazy"
                  width={358}
                  height={351}
                />
              </a>

              <a
                className="media-item"
                href="https://bens-digital-change.com/employeur#etape4"
                target="_blank"
                rel="noopener noreferrer"
              >
                <h4>
                  4. Réception de vos fonds (en EUR) en 24 h (jour ouvré){" "}
                </h4>
                <img
                  src="/img/sol-01_emp.png"
                  alt="Sol 04"
                  loading="lazy"
                  width={351}
                  height={363}
                />
              </a>
            </div>
          </div>
          <div className="box-col solutions-top-right">
            <h2>
              <b>Nouveau Service</b>
            </h2>
            <h2>
              Commencez à réceptionner votre salaire directement de votre
              employeur
            </h2>
            <p className="box-long-desc">
              Avec notre service de change en ligne, il vous est maintenant
              possible de réceptionner votre salaire sur votre compte en euros
              d’une manière simple, rapide et sécurisée, sans avoir à ouvrir un
              compte bancaire en Suisse. Voilà de quoi{" "}
              <b>économiser des frais</b> liés à la tenue de compte, qui peuvent
              s’avérer être assez onéreux.
            </p>
            <a
              href="https://bens-digital-change.swiss/register"
              target="_blank"
              rel="noopener noreferrer"
            >
              Inscription Gratuite et sans engagement
            </a>
            <a
              href="https://calendly.com/bens_digital/demande-d-assistance"
              target="_blank"
              rel="noopener noreferrer"
            >
              Contacter nos conseillers
            </a>
          </div>
        </div>

        <div className="section-08-box solutions-bottom">
          <div className="box-col">
            <img
              src="https://bens-digital-change.com/images/v2/get-mobile-back.webp"
              alt="Get Mobile"
              className="box-img"
              loading="lazy"
              width={733}
              height={671}
            />
          </div>
          <div className="box-col">
            <h2 className="box-title">
              Notre solution est disponible sur mobile
            </h2>
            <img
              src="/img/bens-title-dark.svg"
              alt="Bens"
              className="box-desc-img"
              loading="lazy"
              width={399}
              height={51}
            />
            <p className="box-long-desc">
              Réalisez l’ensemble de vos opérations de change sur notre
              application disponible sur Android comme sur IOS. Vous souhaitez
              changer votre devise à un moment précis ?
            </p>
            <p className="box-long-desc">
              Notre application vous offre la possibilité de créer une alerte
              afin de vous prévenir quand le taux de change atteint celui que
              vous désirez.
            </p>
            <a
              href="https://bens-digital-change.ch/download-mobile-app"
              className="box-store"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="https://bens-digital-change.com/images/v2/bens-stores.webp"
                alt="Bens Store"
                loading="lazy"
              />
            </a>
          </div>
        </div>
      </div>
      <div
        className="solutions-back"
        style={{
          background:
            "linear-gradient(180deg, " +
            CurrentTheme(config.theme)["color"][0] +
            " 0%, " +
            CurrentTheme(config.theme)["color"][1] +
            " 100%)",
        }}
      ></div>
    </div>
  );
}
